import { number, shape, string } from 'prop-types'

export const priceType = {
  price: number.isRequired,
  net: number.isRequired,
  currencySymbol: string.isRequired,
}

export const priceShapeType = shape(priceType)
